import { render, staticRenderFns } from "./AgentMemberMainMenuComponent.vue?vue&type=template&id=8cc12308&scoped=true&"
import script from "./AgentMemberMainMenuComponent.vue?vue&type=script&lang=js&"
export * from "./AgentMemberMainMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgentMemberMainMenuComponent.vue?vue&type=style&index=0&id=8cc12308&prod&scoped=true&lang=css&"
import style1 from "./AgentMemberMainMenuComponent.vue?vue&type=style&index=1&id=8cc12308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc12308",
  null
  
)

export default component.exports